import type { DocTypeSchema } from "@/lib/erp/meta";
import { pruneLocalPlaceholderRows } from "./pruneLocalPlaceholderRows";

/**
 * Remove local (client-created) placeholder rows from child tables before save.
 *
 * Some UIs pre-create multiple blank child rows (e.g. item images) which can trigger
 * Frappe mandatory validation server-side. We only prune rows marked `__islocal`
 * and only when they're "effectively empty" per the shared presence heuristic.
 */
export function pruneLocalPlaceholderChildRowsInDoc(
  doc: Record<string, any>,
  metaSchema: DocTypeSchema,
  getChildSchema: (doctype: string) => DocTypeSchema | null | undefined
): Record<string, any> {
  return pruneLocalPlaceholderRows(doc, metaSchema, (doctype) => getChildSchema(doctype) ?? undefined);
}
